// extracted by mini-css-extract-plugin
export var boldText = "_3a-4";
export var checkboxContainer = "_3a-6";
export var closeIcon = "_3a-g";
export var container = "_3a-0";
export var drawer = "_3a-8";
export var drawerContent = "_3a-9";
export var extraSmallText = "_3a-5";
export var fulfillmentGroupTable = "_3a-e";
export var largeText = "_3a-3";
export var loadingSpinnerContainer = "_3a-h";
export var mediumText = "_3a-2";
export var narrow = "_3a-f";
export var notificationLink = "_3a-j";
export var packageCheckIconContainer = "_3a-7";
export var slideoutHeaderContainer = "_3a-a";
export var slideoutModal = "_3a-c";
export var stickyHeaderWrapper = "_3a-b";
export var table = "_3a-i";
export var tableContainer = "_3a-d";
export var tertiaryText = "_3a-1";